/** Yearly salary bounds, compared in US dollars. */
export const PAY_CURRENCY = "USD";
export const DEFAULT_PAY_MIN = 65_000;
export const DEFAULT_PAY_MAX = 125_000;

export function payAmount(value: string): number | null {
    const digits = value.trim().replace(/[$,\s]/g, "");
    return /^\d{1,9}$/.test(digits) ? Number(digits) : null;
}
